// src/pages/PrivacyPolicy.jsx
import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={{ padding: "20px", lineHeight: "1.6", marginTop:'20px', marginLeft:'30px' }}>
      <h1>Privacy Policy</h1>

      <p>
        Welcome to <strong>Shop World</strong>. Your privacy is important to us.
        This Privacy Policy explains how we collect, use, and protect your information.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Name, phone number, and email address</li>
        <li>Delivery address and location data</li>
        <li>Order and transaction details</li>
        <li>Device and usage information</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To process and deliver your orders</li>
        <li>To improve our services and user experience</li>
        <li>To communicate order updates and offers</li>
        <li>To ensure security and prevent fraud</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>
        We do not sell your personal data. However, we may share information with:
      </p>
      <ul>
        <li>Delivery partners to fulfill orders</li>
        <li>Payment gateways for secure transactions</li>
        <li>Service providers like Firebase for app functionality</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We implement appropriate security measures to protect your data.
        However, no method of transmission over the internet is 100% secure.
      </p>

      <h2>5. Cookies and Tracking</h2>
      <p>
        We may use cookies and analytics tools to enhance user experience and
        analyze app performance.
      </p>

      <h2>6. Your Rights</h2>
      <ul>
        <li>You can update or delete your account information</li>
        <li>You can contact us for any privacy-related concerns</li>
      </ul>

      <h2>7. Third-Party Services</h2>
      <p>
        Our app may use third-party services such as Firebase, Google Maps,
        and payment providers which have their own privacy policies.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be posted on this page.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions, contact us at:
        <br />
        📧 support@theshopworld.com
      </p>

      <p style={{ marginTop: "20px" }}>
        <strong>Last Updated:</strong> April 2026
      </p>
    </div>
  );
}